import { defineStore } from 'pinia'

export const useCompanyStore = defineStore('company', {
  state: () => ({
    loading: false,
    company: {
      id: null,
      name: '',
      business_name: '',
      cuit: '',
      address: '',
      phone: '',
      email: '',
      logo_url: '',
      timezone: '',
      created_at: null,
      updated_at: null
    },
    configurations: []
  }),

  getters: {
    // Getter principal - siempre retorna un objeto válido
    getCompany: (state) => {
      return state.company || {}
    },
    
    // Getter para verificar si la empresa está cargada
    isLoaded: (state) => {
      return state.company && state.company.id !== null
    },
    
    // Getter para configuraciones de la empresa
    getConfigurations: (state) => {
      return state.configurations || []
    },
    
    // Getter para obtener configuración específica
    getConfiguration: (state) => {
      return (key) => {
        const config = state.configurations.find(c => c.key === key)
        return config ? config.value : null
      }
    },
    
    // Getters específicos comunes
    companyName: (state) => {
      return state.company?.name || ''
    },
    
    businessName: (state) => {
      return state.company?.business_name || ''
    },
    
    companyCuit: (state) => {
      return state.company?.cuit || ''
    },
    
    companyLogo: (state) => {
      return state.company?.logo_url || ''
    }
  },

  actions: {
    // Establecer datos de empresa desde respuesta de API
    setCompanyData({ company, configurations }) {
      if (company) {
        this.company = company
      }
      if (configurations) {
        this.configurations = configurations
      }
    },
    
    setCompany(companyData) {
      this.company = companyData
    },
    
    setConfigurations(configurations) {
      this.configurations = configurations
    },
    
    // Actualizar configuración específica
    updateConfiguration({ key, value }) {
      const configIndex = this.configurations.findIndex(c => c.key === key)
      if (configIndex !== -1) {
        this.configurations[configIndex].value = value
      } else {
        this.configurations.push({ key, value })
      }
    },
    
    // Limpiar datos de empresa (logout)
    clearCompany() {
      this.company = {
        id: null,
        name: '',
        business_name: '',
        cuit: '',
        address: '',
        phone: '',
        email: '',
        logo_url: '',
        timezone: '',
        created_at: null,
        updated_at: null
      }
      this.configurations = []
    },
    
    setLoading(value) {
      this.loading = value
    }
  }
})